export default __webpack_public_path__ + "static/media/withButtons.c95ccc50.png";